module.exports = __webpack_public_path__ + "static/media/Opt_out_bell.2735573e.svg";